import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18 5C18.9214 5 19.8929 5.23169 20.676 5.75374C21.4671 6.28116 22 7.07483 22 8C22 8.92517 21.4671 9.71884 20.676 10.2463C19.8929 10.7683 18.9214 11 18 11C17.0786 11 16.107 10.7683 15.324 10.2463C14.5328 9.71884 14 8.92517 14 8C14 7.07483 14.5328 6.28116 15.324 5.75374C16.107 5.23169 17.0786 5 18 5ZM5.99999 10.8292C6.40944 10.6848 6.79381 10.4488 7.12131 10.1213C8.29288 8.94975 8.29288 7.05025 7.12131 5.87868C5.94974 4.70711 4.05024 4.70711 2.87867 5.87868C1.70709 7.05025 1.70709 8.94975 2.87867 10.1213C3.20616 10.4488 3.59053 10.6848 3.99999 10.8292V12H1.99999V14H3.99999V15.5857L1.58594 17.9986L2.99984 19.4132L5.00035 17.4135L7.00291 19.4132L8.41609 17.9979L5.99999 15.5854V14H7.99999V12H5.99999V10.8292ZM9.49999 7H12.5V9H9.49999V7ZM18 13C18.9214 13 19.8929 13.2317 20.676 13.7537C21.4671 14.2812 22 15.0748 22 16C22 16.9252 21.4671 17.7188 20.676 18.2463C19.8929 18.7683 18.9214 19 18 19C17.0786 19 16.107 18.7683 15.324 18.2463C14.5328 17.7188 14 16.9252 14 16C14 15.0748 14.5328 14.2812 15.324 13.7537C16.107 13.2317 17.0786 13 18 13ZM9.49999 15H12.5V17H9.49999V15Z"}}]};

const UsercaseFilled = Vue.extend<IconProps>({
  name: 'UsercaseFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'usercase-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default UsercaseFilled;
